import styled from 'styled-components';

export const Label = styled.div`
    font-weight: 700;
    background-color: #f8f8f8;
    padding: 5px 10px;
    font-size: 12px;

    @media (min-width: 600px) {
        font-size: 16px;
        padding: 12px 18px;
    }
`;
